import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { firebaseApp } from '../firebase/config';
import { saveFcmToken } from './fcmTokenService';

let messaging = null;

function getMsg() {
  if (!messaging) {
    messaging = getMessaging(firebaseApp);
  }
  return messaging;
}

/**
 * 웹 브라우저 FCM 토큰 발급 + Firestore 저장
 * vapidKey는 Firebase Console > Cloud Messaging > Web Push certificates에서 발급
 */
export async function requestWebPushToken(uid, vapidKey) {
  if (!uid || !vapidKey) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('[WebPush] 알림 권한 거부됨');
      return null;
    }
    const token = await getToken(getMsg(), { vapidKey });
    if (token) {
      await saveFcmToken(uid, token, 'web');
      console.log('[WebPush] 토큰 저장 완료:', token.slice(0, 20));
    }
    return token;
  } catch (err) {
    console.warn('[WebPush] 토큰 발급 실패:', err.message);
    return null;
  }
}

/**
 * 포그라운드 메시지 수신 리스너
 */
export function onForegroundMessage(callback) {
  return onMessage(getMsg(), (payload) => {
    callback(payload);
  });
}
